import script from "./AddEnrichmentDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddEnrichmentDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AddEnrichmentDialog.vue?vue&type=style&index=0&id=75f099fd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f099fd"]])